import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useLoginWizardState() {
  return useAppState();
}

export function useLoginWizardActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function setFeedback(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: response.feedbackMessage || null,
      feedbackVariant: response.feedbackVariant || null,
    }));
  }

  function onError(feedback) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedback.feedbackMessage || null,
      feedbackVariant: feedback.feedbackVariant || null,
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    setFeedback,
    onResponse,
    onError,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
